import { gsap } from 'gsap';
import Flickity from 'flickity'
import 'flickity-imagesloaded'

function flickityInit () {
    const block = document.querySelector( '.wp-block-drsblocks-stories' )
    if ( !block ) return

    const mql = window.matchMedia( '(min-width: 768px)' )
    if ( mql.matches ) return

    const items = document.querySelectorAll( '.wp-block-drsblocks-story' )
    if ( !items.length ) return
    const holder = document.querySelector( '.wp-block-drsblocks-stories__inner' )
    new Flickity( holder, {
        prevNextButtons: false,
        cellAlign: 'left',
        groupCells: false,
        imagesLoaded: true,
        pageDots: false,
        percentPosition: true,
        autoPlay: false,
        adaptiveHeight: true,
        cellSelector: '.wp-block-drsblocks-story',
        selectedAttraction: 0.05,
        wrapAround: false,
        friction: 0.5
    } )
}

export const initRotation = () => {
    const block = document.querySelector( '.wp-block-drsblocks-stories' )
    if ( !block ) return

    const mql = window.matchMedia( '(min-width: 1024px)' )
    if ( !mql.matches ) return

    gsap.to( '.wp-block-drsblocks-stories__rotate svg:nth-child(2)', {
        rotation: 360,
        duration: 30,
        ease: 'none',
        repeat: -1,
    } )
}

document.addEventListener( 'DOMContentLoaded', initRotation )

window.addEventListener( 'load', flickityInit )